export default __webpack_public_path__ + "static/media/a_wdt_c_5.e418f0ad.mp3";